import React, { useEffect, useState } from "react";
import "./UserLatestScoresTable.css";
import LatestUserScoresTable from "./LatestUserScoresTable/LatestUserScoresTable";
import LatestPracScoresTable from "./LatestPracScoresTable/LatestPracScoresTable";

function UserLatestScoresTable({ userData }) {
  const [empathyScores, setEmpathyScores] = useState([]);
  const [selectedQuiz, setSelectedQuiz] = useState("user");

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/admin/users/latest-scores`,
      {
        method: "GET",
        credentials: "include",
      }
    )
      .then((res) => res.json())
      .then((data) => setEmpathyScores(data))
      .catch((err) => console.error("Error fetching scores:", err));
  }, [userData]);

  return (
    <div className="quiz-questions-table">
      <div className="table-header">
        <h3>Latest Empathy Scores of Users</h3>
      </div>
      <div className="radio-group" style={{ margin: "1rem 0" }}>
        <label style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <input
            type="radio"
            value="user"
            checked={selectedQuiz === "user"}
            onChange={() => setSelectedQuiz("user")}
          />
          User Quiz
        </label>
        <label style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <input
            type="radio"
            value="practitioner"
            checked={selectedQuiz === "practitioner"}
            onChange={() => setSelectedQuiz("practitioner")}
          />
          Practitioner Quiz
        </label>
      </div>
      <div style={{ marginBottom: "8px", fontStyle: "italic", color: "#555" }}>
        Tip: Click a column header to sort by that column.
      </div>
      {selectedQuiz === "user" ? (
        <LatestUserScoresTable
          scores={empathyScores.filter((score) => score.quiz === selectedQuiz)}
        />
      ) : (
        <LatestPracScoresTable
          scores={empathyScores.filter((score) => score.quiz === selectedQuiz)}
        />
      )}
    </div>
  );
}

export default UserLatestScoresTable;
